import { render, staticRenderFns } from "./PanelViewTest.vue?vue&type=template&id=28c969e7&scoped=true&"
import script from "./PanelViewTest.vue?vue&type=script&lang=js&"
export * from "./PanelViewTest.vue?vue&type=script&lang=js&"
import style0 from "./PanelViewTest.vue?vue&type=style&index=0&id=28c969e7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c969e7",
  null
  
)

export default component.exports